<template>
  <div class="shop-item relative">
    <div class="flex gap-2 items-center flex-1">
      <div class="flex gap-3 bg-white rounded-lg p-2 pl-0 items-center">
        <vs-button
          @click="$emit('add')"
          size="small"
          icon-pack="feather"
          icon="icon-plus"
        ></vs-button>
        <span
          style="font-size: 16px"
          class="font-black w-4 flex justify-center items-center"
          >{{ product.unit }}
        </span>
        <vs-button
          @click="$emit('remove')"
          size="small"
          style="border-color: #c10000; color: #c10000 !important"
          class="buttons border"
          icon-pack="feather"
          icon="icon-minus"
        ></vs-button>
      </div>
      <span class="title">
        {{ product.product.title }}
      </span>
    </div>
    <div class="flex gap-2 items-center justify-end">
      <span class="price">
        {{ product.price.toString().numberFormat() }} ریال
      </span>
      <button @click="$emit('remove-all')" style="padding: 2px" class="w-6 h-6">
        <img class="w-full" src="../../../../assets/icons/trash.svg" />
      </button>
    </div>
    <div
      style="
        height: 0.1px;
        width: 100%;
        filter: blur(1px);
        background-color: gray;
        transform: scaleY(0.5);
      "
      class="absolute bottom-0 rounded-full left-0 right-0 mx-auto"
    ></div>
  </div>
</template>

<script>
  export default {
    name: "ShopItem",
    props: {
      product: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<style scoped lang="scss">
  .shop-item {
    // background-color: #f0efef;
    display: flex;
    gap: 8px;
    align-items: center;
    justify-items: space-between;
    border-radius: 12px;
    padding: 12px 4px;

    & + .shop-item {
      margin-top: 8x;
    }

    .buttons {
      background-color: #fff !important ;
      color: #00000099 !important;
      box-shadow: 0 !important;
    }

    .title {
      max-width: 192px;
      font-size: 14px;
      font-weight: 400;
      color: #000;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      /* number of lines to show */
      line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    .price {
      font-size: 12px;
      font-weight: 400;
      color: #00000099;
    }
  }
</style>
